/** Get items from an array on the current page.
 * @param items An array of items.
 * @param currentPage Current selected page.
 * @param itemsPerPage Number of items per page.
 */
export function getPageItems(items, currentPage, itemsPerPage) {
    return items.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
}
//# sourceMappingURL=pagination.js.map